export default "__VITE_ASSET__VTtC5tx3__"